// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product__body[data-v-9e3330e6]:not(.list){width:100%}.hidePrice[data-v-9e3330e6]{align-items:center;display:flex;flex-wrap:wrap;font-size:12px;gap:3px}@media(max-width:1024px){.hidePrice[data-v-9e3330e6]{font-size:14px}}@media(max-width:480px){.hidePrice[data-v-9e3330e6]{font-size:10px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
